import gql from 'graphql-tag';

export const ATTACH_TO_PAGE = gql`
  mutation($contentPageId: Int!, $styleId: Int!) {
    cssStyle {
      attachStyleToContentPage(contentPageId: $contentPageId, styleId: $styleId)
    }
  }
`;
